import React from "react";
import orderBy from "lodash/orderBy";
import Box from "@mui/material/Box";

export default function ReceivingReportNumberComponent({ entity }) {
  if (!entity.shipmentItems) return "";

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      width="100%"
      maxHeight="100%"
      overflow="auto"
      sx={{ overflowX: "hidden" }}
    >
      {orderBy(entity.shipmentItems, v => v.shipment.shipmentId, "asc").map((item, index) => (
        <Box key={index} component="div" sx={{ whiteSpace: "nowrap" }}>
          {item.shipment.shipmentId} ({item.quantity})
        </Box>
      ))}
    </Box>
  );
}
